var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');

function createState() {
  return {
    groups: prop(),
    groupsLoading: prop(true),
    groupsError: prop('')
  };
}

function load(state, filterGroups) {
  state.groupsLoading(true);
  state.groupsError('');

  return loaders.requestWithLoader({
    url: '/api/v1/group/',
    method: 'GET'
  })
  .then(function (groups) {
    state.groups(filterGroups(groups));
    return state.groups();
  })
  .catch(function (error) {
    console.error('Unable to load groups for permissions:', error);
    state.groupsError('Unable to load groups. Please try again.');
    return null;
  })
  .then(function (result) {
    state.groupsLoading(false);
    m.redraw();
    return result;
  });
}

module.exports = {
  createState: createState,
  load: load
};
